module.exports = __webpack_public_path__ + "static/media/prize-desktop.f8e2720f.png";